import "./MidPageCta.css";
import { motion, useReducedMotion } from "framer-motion";

function MidPageCta() {
  const prefersReducedMotion = useReducedMotion();

  return (
    <motion.section
      className="landing-midcta"
      initial={prefersReducedMotion ? false : { opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.6 }}
      transition={{ duration: 0.5, ease: [0.16, 1, 0.3, 1] }}
    >
      <p>Készen állsz kipróbálni?</p>
      <a href="https://app.tablify.hu/register" className="landing-btn-primary">
        Ingyenes Kipróbálás
      </a>
    </motion.section>
  );
}

export default MidPageCta;
